import { useMutation } from '@tanstack/react-query'
import { 
  createValuationPropertyRequest, 
  type ValuationPropertyRequest, 
  type ValuationPropertyResponse 
} from '../services/valuationPropertyService'

/**
 * Hook to create a valuation property request using useMutation
 * The apiClient already handles Bearer token automatically from localStorage
 */
export const useCreateValuationPropertyRequest = () => {
  return useMutation({
    mutationFn: (data: ValuationPropertyRequest): Promise<ValuationPropertyResponse> => {
      return createValuationPropertyRequest(data)
    },
    onSuccess: (data) => {
      console.log('✅ Valuation property request created successfully:', data)
    },
    onError: (error: any) => {
      console.error('❌ Error creating valuation property request:', error)
    },
  })
}

export default useCreateValuationPropertyRequest

